import { useEffect, useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { FileContext, FileContextFilters, FileContextValues, fileContextsApi } from './fileContextsApi';

export function useFileEntities() {
  return useQuery({ queryKey: ['file-contexts', 'entities'], queryFn: fileContextsApi.entities });
}
export function useFileContexts() {
  const [search, setSearch] = useState('');
  const [filters, setFilters] = useState<FileContextFilters>({ search: '', entity: '', sort: 'context_name', page: 1 });
  useEffect(() => {
    const timer = window.setTimeout(() => setFilters((current) => ({ ...current, search: search.trim(), page: 1 })), 250);
    return () => window.clearTimeout(timer);
  }, [search]);
  const query = useQuery({ queryKey: ['file-contexts', 'list', filters], queryFn: () => fileContextsApi.list(filters) });
  const client = useQueryClient();
  const deletion = useMutation({ mutationFn: fileContextsApi.remove, onSuccess: () => client.invalidateQueries({ queryKey: ['file-contexts'] }) });
  const remove = (context: FileContext): void => {
    if (deletion.isPending || !window.confirm(`Удалить контекст «${context.context_name}»?`)) return;
    deletion.mutate(context.context_id);
  };
  return { query, filters, setFilters, search, setSearch, remove, deletion };
}
export function useFileContext(id?: number) {
  return useQuery({ queryKey: ['file-contexts', 'detail', id], queryFn: () => fileContextsApi.get(id!), enabled: id !== undefined });
}
export function useFileContextSave(id?: number) {
  const client = useQueryClient();
  return useMutation({ mutationFn: (values: FileContextValues) => id === undefined ? fileContextsApi.create(values) : fileContextsApi.update(id, values), onSuccess: () => client.invalidateQueries({ queryKey: ['file-contexts'] }) });
}
